import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import { COMPANY } from "@/data/siteData";

const links = [
  { to: "/", label: "Home", id: "nav-home-link" },
  { to: "/services", label: "Services", id: "nav-services-link" },
  { to: "/contact", label: "Contact Us", id: "nav-contact-link" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const linkClass = ({ isActive }) =>
    `text-sm tracking-wide transition-colors duration-200 ${isActive ? "text-primary font-medium" : "text-foreground/70 hover:text-primary"}`;

  return (
    <header data-testid="site-navbar" className="sticky top-0 z-50 border-b border-border/50 bg-background/90 backdrop-blur-xl">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-10">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3">
          <img src="/logo-icon.svg" alt="" className="h-12 w-12 sm:h-14 sm:w-14" />
          <span className="font-display text-xl font-medium tracking-tight text-[#1F6B2A] sm:text-2xl">{COMPANY.name}</span>
        </Link>

        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={l.id} className={linkClass}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="nav-inquiry-cta"
            className="hidden items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-medium text-white shadow-sm transition-[transform,box-shadow,background-color] duration-200 hover:-translate-y-0.5 hover:bg-primary/90 hover:shadow-md sm:flex"
          >
            Request Service <ArrowRight className="h-4 w-4" strokeWidth={1.75} />
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-border text-foreground md:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-border/50 bg-background px-6 py-6 md:hidden">
          <nav className="flex flex-col gap-5">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)} data-testid={`${l.id}-mobile`} className={linkClass}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} data-testid="nav-inquiry-cta-mobile" className="inline-flex w-fit items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-medium text-white">
              Request Service <ArrowRight className="h-4 w-4" />
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};
